/* eslint-disable */
import httpFactory from "./http";
const $http = httpFactory.build("student");
var QiuPen = {
    highlighter: null
}

var classes = [
    // 'hl-red', 'hl-orange', 'hl-yellow', 'hl-green', 'hl-blue', 'hl-purple',
    // 'line-red', 'line-orange', 'line-yellow', 'line-green', 'line-blue', 'line-purple',
    'line-light',"hl-light"
]
var classAppliers = []

function Highlight(chapterPos, highlight) {
    this.chapterPos = chapterPos
    this.highlight = highlight
}

QiuPen.init = function () {
    rangy.init(); // 初始化rangy模块
    classes.forEach(function (item) {
        var classApplier = rangy.createClassApplier(item, {
            ignoreWhiteSpace: true,
            elementTagName: 'span'
        })
        classAppliers.push(classApplier)
    })
}

QiuPen.create = function (document) {
    QiuPen.highlighter = rangy.createHighlighter(document); // 创建一个highlighter
    classAppliers.forEach(function (item) {
        QiuPen.highlighter.addClassApplier(item)
    })
}

QiuPen.resetSave = async function (book, bookId, selectedText) {
    var chapterPos = book.index
    var serStr = QiuPen.highlighter.serialize();
    console.log(serStr)   
    new Highlight(chapterPos, serStr, selectedText)
}
QiuPen.save = async function (book, bookKey,chapter_name, note, selectedText, cfi, color,type,id) {
    console.log('selectedText', selectedText)
    // var store = storage.get('highlight', {})

    // store[bookKey] = store[bookKey] || []
    var chapterPos = book.index
    var serStr = QiuPen.highlighter.serialize()
    console.log(serStr)
    
    var hlObj = new Highlight(chapterPos, serStr, selectedText)
    hlObj.id = '' + new Date().getTime()
    hlObj.createTime = new Date().getTime()
    hlObj.cfi = cfi
    hlObj.color = color
    hlObj.note = note;
    hlObj.selectedText = selectedText
    console.log(note,"note")
    if(id) {
        await $http.put(`/api/app/myEbook/note/${id}`, {
            note: note,
        });
    }else {
        await $http.post("/api/app/myEbook/note", {
            chapter: chapterPos,
            ebook_id: bookKey,
            chapter_name,
            note: note,
            highlight: hlObj.highlight,
            text: selectedText,
            cfi,
            color,
            type,
          });
    }  
    // store[bookKey].unshift(hlObj)
    // storage.set('highlight', store); 
}

QiuPen.load = async function (book, bookKey) {
    console.log('bookKey', bookKey)
    let res = await $http.get("/api/app/myEbook/note", {
        ebook_id: bookKey,
      },
      {
        showLoading: false,
      },);
    var chapterPos = book.index
    var result = null
    res.forEach(function (item) {
        if (item.chapter == chapterPos) {
            result = item
            if (!result) return
            QiuPen.highlighter.deserialize(result.highlight)
        }
    })
}

window.QiuPen = QiuPen
